// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditStep_deleteButton__a03v5","field":"EditStep_field__ulmsr","text":"EditStep_text__VO1tP"};